export default __webpack_public_path__ + "static/media/logo-amex.e56594fa.svg";